// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/css/admin.css
// module id = 634
// module chunks = 1